import { Pipe, PipeTransform } from '@angular/core';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';

@Pipe({
  name: 'PCustomMonthFormat'
})
export class PCustomMonthFormatPipe implements PipeTransform {

  transform(value: string): string {
    const date = parse(value, "MM-yyyy", new Date(), {
      locale: es
    });
    const formattedDate = format(date, "MMMM 'del' yyyy", { locale: es });

    return formattedDate;
  }

}
